module.exports = __webpack_public_path__ + "static/media/Apple iMac.78b79dd2.png";